import { useTranslation } from "react-i18next";
import { BorderGreyBox, BoxSpg, CardSpg } from "@duosoftbg/nacid-components";
import { CardContent } from "@mui/material";
import ARUniEntryRequestFilterForm from "../../../../components/registers/request/arUni/form/ARUniEntryRequestFilterForm";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import ARUniEntryRequestList from "../../../../components/registers/request/arUni/ARUniEntryRequestList";

const ARUniEntryRequestListPage = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper centerTitle title={t("t.arUniEntryRequest.list")}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ position: "relative" }}>
          <BoxSpg>
            <BorderGreyBox>
              <ARUniEntryRequestFilterForm />
            </BorderGreyBox>
            <ARUniEntryRequestList />
          </BoxSpg>
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};
export default ARUniEntryRequestListPage;
